import { ViewLocalV1EventManagePage } from "./ViewLocalV1EventManagePage";

export default ViewLocalV1EventManagePage;
